import React from 'react';
import { Chip } from '@mui/material';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../../../constants';

const FilterOutput = ({ filter, filterMenu, onRemoveFilter }) => {
    const plotFilterValue = (key) => {
        const config = filterMenu[key];
        switch (config.inputType) {
            case 'text':
            case 'number':
                return (
                    <Chip
                        size='small'
                        label={
                            <span>
                                <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {filter[key]}
                            </span>
                        }
                        onDelete={() => onRemoveFilter(key)}
                    />
                );
            case 'dropdown': {
                const { options, valueKey, labelKey, multiple } = config;
                if (multiple) {
                    const selected = options?.filter((item) =>
                        filter[key].toString().split(',').includes(item[valueKey].toString())
                    );
                    const value = selected?.map((item) => item[labelKey]).join(', ');
                    return value ? (
                        <Chip
                            size='small'
                            label={
                                <span>
                                    <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {value}
                                </span>
                            }
                            onDelete={() => onRemoveFilter(key)}
                        />
                    ) : null;
                } else {
                    const found = options?.find((item) => item[valueKey] === filter[key]);
                    return found ? (
                        <Chip
                            size='small'
                            label={
                                <span>
                                    <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {found[labelKey]}
                                </span>
                            }
                            onDelete={() => onRemoveFilter(key)}
                        />
                    ) : null;
                }
            }
            case 'date':
                return (
                    <Chip
                        size='small'
                        label={
                            <span>
                                <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>:{' '}
                                {moment(filter[key]).format(config.format || dateMonthYearDateFormat)}
                            </span>
                        }
                        onDelete={() => onRemoveFilter(key)}
                    />
                );
            case 'checkbox':
                return (
                    <Chip
                        size='small'
                        label={
                            <span>
                                <span style={{ fontWeight: 500, fontFamily: 'Conv_IBMPlexSans-Medium' }}>{config.title}</span>: {filter[key] ? 'Yes' : 'No'}
                            </span>
                        }
                        onDelete={() => onRemoveFilter(key)}
                    />
                );
            default:
                return null;
        }
    };

    const orderedFilter = Object.keys(filterMenu).reduce((acc, key) => {
        if (filter[key] !== undefined && filter[key] !== null && filter[key] !== '') {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

    return (
        <div className='filter-result' style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px', minWidth: 0, marginTop:'4px' }}>
            <ul className='list-inline' style={{ display: 'contents' }}>
                {Object.keys(orderedFilter).map((key, index) =>
                    filterMenu[key] ? (
                        <li key={index} className='list-inline-item'>
                            {plotFilterValue(key)}
                        </li>
                    ) : null
                )}
                {filter && Object.keys(filter).length > 1 && (
                    <li className='list-inline-item'>
                        <Chip
                            color='primary'
                            size='small'
                            label='Clear All'
                            onDelete={() => onRemoveFilter('all')}
                        />
                    </li>
                )}
            </ul>
        </div>
    );
};

export default FilterOutput;
